import { useLocation } from 'react-router'

/**
 * location.state를 사용해 이전 pathname을 찾아 올바른 접근인지 확인하는 hook
 * @param prevPathname 이전 주소와 비교할 주소 또는 주소 목록
 * @returns boolean
 */
export function useCheckPrevPathname(prevPathname: string | string[]) {
  const location = useLocation()

  if (!location.state?.prevPathname) {
    return false
  }

  if (typeof prevPathname === 'string') {
    return location.state?.prevPathname !== prevPathname
  }

  return prevPathname.includes(location.state?.prevPathname)
}
